//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ATextblock from "../../../components/ATextblock.vue";

export default {
  name: "NewDesignCaseStudy",
  components: { ATextblock },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  computed: {
    heroBlock() {
      return {
        hidden: this.data.attributes.hidden || false,
        title: this.data.attributes.headline || "",
        text: this.data.attributes.page_description || "",
        variant: "primary",
      };
    },
  },
};
